var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"width":"420px","visible":true},on:{"close":function($event){return _vm.$emit('close')}}},[_c('p',[_vm._v("Ссылка на восстановление пароля"),_c('br'),_vm._v("отправлена на указанную вами электронную почту.")])])}
var staticRenderFns = []

export { render, staticRenderFns }